/* eslint-disable react/no-array-index-key */
import Carousel from '@comp/Carousel/Carousel';
import styled from '@emotion/styled';
import useWindowSize from '@hooks/useWindowSize';
import { ICONS_COURSE_CONTAINER_WIDTH } from '@styles/constants/spacings';
import { mediaQuery, Spacings } from '@styles/index';
import SectionTitle from '@unicons-base/SectionTitle/SectionTitle';
import React, { useMemo } from 'react';
import LearningOutcomeCard from './LearningOutcomeCard';

type LearningOutcomeType = {
  item: string;
  title: string;
  contentType: string;
};

interface LearningOutcomesProps {
  learningOutcomes: LearningOutcomeType[];
}

const CarouselComp = Carousel as any;

const LearningOutcomesWrapper = styled.div`
  max-width: ${ICONS_COURSE_CONTAINER_WIDTH};
  margin: 0 auto ${Spacings.SPACING_20B};
  ${mediaQuery.uptoTablet} {
    margin: 0 auto ${Spacings.SPACING_12B};
    max-width: 100%;
    overflow: hidden;
  }
  ${mediaQuery.uptoMobile} {
    overflow: hidden;
    margin: 0 ${Spacings.SPACING_4B} ${Spacings.SPACING_8B};
    padding: ${Spacings.SPACING_8B} 0;
    border-bottom: 1px solid var(--color-i-icon-dark-button);
    border-top: 1px solid var(--color-i-icon-dark-button);
  }
`;
const LearningOutcomes: React.FC<LearningOutcomesProps> = ({
  learningOutcomes
}) => {
  const totalCount = learningOutcomes.length;
  const { isMobile } = useWindowSize();

  const gridColumn = useMemo(
    () => (isMobile ? 'span 4' : 'span 6'),
    [isMobile]
  );

  const gridTemplateColumns = useMemo(() => {
    if (isMobile) return (learningOutcomes.length || 1) * 5;
    return (learningOutcomes.length || 1) * 6;
  }, [isMobile, learningOutcomes]);

  return (
    <LearningOutcomesWrapper>
      <SectionTitle title="Course overview" />
      <CarouselComp
        numberOfItems={4}
        minItems={1}
        showControls
        showInfo={false}
        gridTemplateColumns={gridTemplateColumns}
        gridColumnGap={isMobile ? Spacings.SPACING_2B : Spacings.SPACING_3B}
        gridColumn={gridColumn}
        itemGridColumn={gridColumn}
        isUnIconArrow
        showBottomGap={false}
        paddingBottom="0"
      >
        {learningOutcomes.map((outcome, index) => (
          <React.Fragment key={index}>
            <LearningOutcomeCard
              totalCount={totalCount}
              title={outcome.title}
              gridColumn="span 4"
              outcomeSrc={outcome.item}
            />
          </React.Fragment>
        ))}
      </CarouselComp>
    </LearningOutcomesWrapper>
  );
};

LearningOutcomes.displayName = 'LearningOutcomes';

export default LearningOutcomes;
